<div
  class="mb-2"
  [ngClass]="
    baseService.isMobile
      ? 'd-flex flex-column gap-2 align-items-center'
      : 'd-flex flex-row justify-content-between gap-1'
  "
>
  <ng-container *ngTemplateOutlet="baseService.isMobile ? Dropdown : Statuses"></ng-container>
  <ng-container *ngTemplateOutlet="baseService.isMobile ? Statuses : Dropdown"></ng-container>
  <ng-template #Statuses>
    @if (filterStatuses?.length) {
      <div class="mt-2 d-flex gap-2 flex-wrap" [ngClass]="{ 'justify-content-center': baseService.isMobile }">
        @for (item of filterStatuses; track item) {
          <h5 class="text-black">
            <div
              class="badge btn-static click-css"
              [ngStyle]="{ '--color': item.active ? item.color : '#cccccc' }"
              (click)="onFilterChange(item)"
            >
              {{ item.name | translate }}
            </div>
          </h5>
        }
      </div>
    }
  </ng-template>
  <ng-template #Dropdown>
    <app-dropdown
      class="account-box"
      [ngClass]="{ 'w-100': baseService.isMobile }"
      [items]="items"
      [input]="currentChannelId"
      [bindValue]="'id'"
      (onValueChange)="onValueChange($event)"
      [closeOnSelect]="true"
      [searchable]="true"
      placeholder="{{ 'channels' | translate }}"
    ></app-dropdown>
  </ng-template>
</div>
@if (isLoader) {
  <div class="d-flex justify-content-center">
    <app-loader size="small"></app-loader>
  </div>
} @else {
  @if (dataSource$ | async; as dataSource) {
    <div>
      <!--        <table-pagination-->
      <!--                [hidePageSize]="true"-->
      <!--                [length]='dataSource.items.length'-->
      <!--                [pageIndex]='dataSource.pageIndex'-->
      <!--                [pageSize]='dataSource.pageSize'-->
      <!--                dropdownPosition="bottom"-->
      <!--                (page)='onPaginationChange($event)'-->
      <!--                class='mat-paginator-sticky'>-->
      <!--        </table-pagination>-->
      <div class="d-flex flex-column gap-3 text-black">
        @for (item of dataSource.items; track item) {
          <mat-card class="gap-2 shadow-sm d-flex p-3 rounded">
            <div class="d-flex w-100 flex-column gap-2">
              <div class="packets-header d-flex w-100 justify-content-between">
                <div class="title">
                  <div class="fs-4 w-100">{{ item.categories_labels[0] }}</div>
                  <div class="gap-1">
                    <div class="fs-6 fw-light text-muted">
                      @if (item.package_type === 'BASIC') {
                        {{ 'olx.packages.start' | translate }}
                      }
                      @if (item.package_type === 'PREMIUM') {
                        {{ 'olx.packages.premium' | translate }}
                      }
                      @if (item.package_type === 'MEGA') {
                        {{ 'olx.packages.mega' | translate }}
                      }
                    </div>
                    <div class="fs-6 fw-light text-muted">{{ item.name }}</div>
                  </div>
                </div>
                @if (item.zone_id) {
                  <div class="location w-50 d-flex flex-column text-end">
                    <div class="fw-light text-muted fs-7">{{ 'olx.packages.location' | translate }}:</div>
                    <div class="fw-semibold fs-6">{{ item.location_name }}</div>
                  </div>
                }
              </div>
              <div class="d-flex justify-content-between w-100">
                <div class="info d-flex gap-4">
                  <div class="size flex-column">
                    <div class="fw-light text-muted">{{ 'olx.packages.available' | translate }}:</div>
                    <div class="fs-5">
                      {{ item.left }} / {{ item.size }} {{ 'olx.packages.placements' | translate }}
                    </div>
                  </div>
                  <div class="date flex-column">
                    <div class="fw-light text-muted">{{ 'olx.packages.valid_until' | translate }}:</div>
                    <div class="d-flex flex-column gap-0">
                      <div>
                        <span class="fs-5">{{ item.active_to | date: 'dd.MM.YY в HH:mm' }}</span>
                      </div>
                      <div>
                        <small class="text-muted"
                          >{{ 'olx.packages.active_for' | translate }} {{ item.active_to | daysLeft }}
                          {{ 'olx.packages.days' | translate }}</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="status d-flex align-items-end">
                  @if (item.is_active) {
                    <div class="status-marker status-active" matTooltip="{{ 'olx.packages.active' | translate }}"></div>
                  }
                  @if (!item.is_active) {
                    <div
                      class="status-marker status-inactive"
                      matTooltip="{{ 'olx.packages.inactive' | translate }}"
                    ></div>
                  }
                </div>
              </div>
            </div>
          </mat-card>
        }
      </div>
      @if (!dataSource.items?.length) {
        <div class="d-flex justify-content-center text-black">
          {{ 'nothing_found' | translate }}
        </div>
      }
    </div>
  }
}
